/* Callisto Jewellery (Horizon) – faner, slider-pile, video, levering, ønskeliste, Style med og Læs mere */
(function () {
  'use strict';

  function initRails(root) {
    root.querySelectorAll('[data-cjh-rail-wrap]').forEach(function (wrap) {
      if (wrap.dataset.cjhBound) return;
      wrap.dataset.cjhBound = '1';
      var prev = wrap.querySelector('[data-cjh-prev]');
      var next = wrap.querySelector('[data-cjh-next]');
      if (!prev || !next) return;

      function activeRail() {
        var rails = wrap.querySelectorAll('[data-cjh-rail]');
        for (var i = 0; i < rails.length; i++) {
          if (rails[i].offsetParent !== null) return rails[i];
        }
        return rails[0];
      }
      function update() {
        var rail = activeRail();
        if (!rail) return;
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
      }
      function go(dir) {
        var rail = activeRail();
        if (!rail) return;
        rail.scrollBy({ left: dir * rail.clientWidth * 0.9, behavior: 'smooth' });
      }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      wrap.querySelectorAll('[data-cjh-rail]').forEach(function (rail) {
        rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      });
      window.addEventListener('resize', update);
      wrap.addEventListener('cjh:tabchange', update);
      update();
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-cjh-tabs]').forEach(function (tabs) {
      if (tabs.dataset.cjhBound) return;
      tabs.dataset.cjhBound = '1';
      var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
      var links = tabs.querySelectorAll('[data-cjh-tab-link]');

      function select(btn, focus) {
        buttons.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        links.forEach(function (link) {
          var on = link.getAttribute('data-cjh-tab-link') === btn.id;
          link.hidden = !on;
        });
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var rail = panel && panel.querySelector('[data-cjh-rail]');
        if (rail) rail.scrollLeft = 0;
        tabs.dispatchEvent(new CustomEvent('cjh:tabchange', { bubbles: false }));
        if (focus) btn.focus();
      }

      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () { select(btn, false); });
        btn.addEventListener('keydown', function (e) {
          var idx = null;
          if (e.key === 'ArrowRight') idx = (i + 1) % buttons.length;
          if (e.key === 'ArrowLeft') idx = (i - 1 + buttons.length) % buttons.length;
          if (e.key === 'Home') idx = 0;
          if (e.key === 'End') idx = buttons.length - 1;
          if (idx !== null) { e.preventDefault(); select(buttons[idx], true); }
        });
      });
    });
  }

  function initVideos(root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('.cjh video').forEach(function (video) {
      if (video.dataset.cjhBound) return;
      video.dataset.cjhBound = '1';
      video.muted = true;
      video.setAttribute('playsinline', '');
      if (reduce) { video.removeAttribute('autoplay'); video.pause(); return; }
      if (!('IntersectionObserver' in window)) {
        if (video.offsetParent !== null) { video.preload = 'auto'; var p0 = video.play(); if (p0 && p0.catch) p0.catch(function () {}); }
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            /* Videoer hentes først, når de faktisk er synlige (skjult mobil/desktop-version hentes aldrig) */
            if (video.preload !== 'auto') video.preload = 'auto';
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.15 });
      io.observe(video);
    });
  }

  function initReveal(root) {
    var els = root.querySelectorAll('.cjh-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initLooks(root) {
    root.querySelectorAll('[data-cjh-look]').forEach(function (look) {
      if (look.dataset.cjhBound) return;
      look.dataset.cjhBound = '1';
      function activate(id, scroll) {
        look.querySelectorAll('[data-cjh-spot]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.cjhSpot === id); });
        look.querySelectorAll('[data-cjh-row]').forEach(function (r) {
          var on = r.dataset.cjhRow === id;
          r.classList.toggle('is-active', on);
          if (on && scroll && window.innerWidth < 960) r.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
      look.querySelectorAll('[data-cjh-spot]').forEach(function (b) {
        b.addEventListener('click', function () { activate(b.dataset.cjhSpot, true); });
        b.addEventListener('mouseenter', function () { activate(b.dataset.cjhSpot, false); });
      });
      look.querySelectorAll('[data-cjh-row]').forEach(function (r) {
        r.addEventListener('mouseenter', function () { activate(r.dataset.cjhRow, false); });
      });
    });
  }

  /* Kollektionsside: flyt editorial-fliser ind i temaets produktgitter */
  function initGridPromos(root) {
    var grid = document.querySelector('.product-grid');
    if (!grid) return;
    root.querySelectorAll('[data-cjc-promo]').forEach(function (tpl) {
      if (tpl.dataset.cjhBound) return;
      tpl.dataset.cjhBound = '1';
      var pos = parseInt(tpl.dataset.position, 10) || 4;
      var node = tpl.content ? tpl.content.firstElementChild.cloneNode(true) : null;
      if (!node) return;
      if (grid.tagName === 'UL' || grid.tagName === 'OL') {
        var li = document.createElement('li');
        li.className = 'product-grid__item cjc-promo-item';
        li.style.gridColumn = 'span ' + (node.style.getPropertyValue('--cjc-span') || 1);
        li.appendChild(node);
        node = li;
      }
      var items = grid.children;
      var ref = items[pos - 1];
      if (ref && ref.nextSibling) grid.insertBefore(node, ref.nextSibling);
      else if (items.length >= pos) grid.appendChild(node);
    });
  }

  /* Produktside: forventet leveringsdato.
     Altid 1–2 dage fra afsendelse. Bestilt efter kl. [data-cutoff] (standard 14) lægges én dag ekstra på.
     Datoen beregnes i dansk tid, også for besøgende i andre tidszoner. */
  function initDelivery(root) {
    var deliveryNodes = root.querySelectorAll('[data-cjp-eta]');
    if (!deliveryNodes.length) return;
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Copenhagen', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23'
    }).formatToParts(new Date());
    var local = {};
    parts.forEach(function (part) { local[part.type] = Number(part.value); });
    deliveryNodes.forEach(function (el) {
      if (el.dataset.businessDays) {
        var businessDate = new Date(Date.UTC(local.year, local.month - 1, local.day));
        var daysRemaining = parseInt(el.dataset.businessDays, 10) || 2;
        while (daysRemaining > 0) {
          businessDate.setUTCDate(businessDate.getUTCDate() + 1);
          if (businessDate.getUTCDay() !== 0 && businessDate.getUTCDay() !== 6) daysRemaining--;
        }
        el.textContent = '– ' + businessDate.toLocaleDateString('da-DK', {timeZone:'UTC',day:'numeric',month:'short'});
        el.setAttribute('aria-label', businessDate.toLocaleDateString('da-DK', {timeZone:'UTC',weekday:'long',day:'numeric',month:'long'}));
        return;
      }
      var min = parseInt(el.dataset.min, 10) || 1;
      var max = parseInt(el.dataset.max, 10) || 2;
      var cutoff = parseInt(el.dataset.cutoff, 10);
      if (isNaN(cutoff)) cutoff = 14;
      var extra = local.hour >= cutoff ? 1 : 0;
      function addDays(n) { return new Date(Date.UTC(local.year, local.month - 1, local.day + n)); }
      var fmt = function (d) {
        return d.toLocaleDateString('da-DK', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });
      };
      var first = addDays(min + extra);
      var last = addDays(max + extra);
      var text = fmt(first) + ' – ' + fmt(last);
      if (el.dataset.cjpFormat === 'short') {
        var day = function (date) { return date.toLocaleDateString('da-DK', { timeZone: 'UTC', day: 'numeric' }); };
        var month = function (date) { return date.toLocaleDateString('da-DK', { timeZone: 'UTC', month: 'short' }); };
        text = first.getUTCMonth() === last.getUTCMonth() && first.getUTCFullYear() === last.getUTCFullYear()
          ? day(first) + '–' + day(last) + ' ' + month(last)
          : day(first) + ' ' + month(first) + ' – ' + day(last) + ' ' + month(last);
        el.setAttribute('aria-label', fmt(first) + ' – ' + fmt(last));
      }
      if (el.textContent !== text) el.textContent = text;
    });
  }

  /* Store overskrifter (fx kollektionsnavne): skaler lange ord ned, så de aldrig skæres af */
  var fitEls = [];
  function fitOne(el) {
    el.style.fontSize = '';
    var max = el.clientWidth;
    if (!max) return;
    var size = parseFloat(window.getComputedStyle(el).fontSize);
    var guard = 0;
    while (el.scrollWidth > max + 1 && size > 18 && guard < 40) {
      size = Math.max(18, Math.floor(size * Math.min(0.97, max / el.scrollWidth)));
      el.style.fontSize = size + 'px';
      guard++;
    }
  }
  function initFit(root) {
    root.querySelectorAll('[data-cj-fit]').forEach(function (el) {
      if (fitEls.indexOf(el) === -1) fitEls.push(el);
      fitOne(el);
    });
  }
  var fitTimer;
  window.addEventListener('resize', function () {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(function () { fitEls.forEach(fitOne); }, 120);
  });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { fitEls.forEach(fitOne); });
  }



  /* Produktside: ønskeliste-knappen (Swish) ved siden af "Tilføj til kurv".
     Appen indsætter knappen efter siden er indlæst, så vi lytter efter ændringer. */
  var WISH_RE = /wishlist|swish|wk-|wk_|wishlist-king/i;
  function looksLikeWish(el) {
    if (!el || el.nodeType !== 1) return false;
    var id = (el.tagName + ' ' + (typeof el.className === 'string' ? el.className : '') + ' ' + (el.id || ''));
    if (WISH_RE.test(id)) return true;
    for (var i = 0; i < el.attributes.length; i++) {
      var a = el.attributes[i];
      if (WISH_RE.test(a.name) || (a.name !== 'style' && WISH_RE.test(a.value))) return true;
    }
    return false;
  }
  function fixWish(scope) {
    var atc = scope.querySelector('.add-to-cart-button');
    if (!atc) return;
    var row = atc.closest('.product-form-buttons');
    if (!row) return;
    var cands = Array.prototype.filter.call(scope.querySelectorAll('*'), function (el) {
      return looksLikeWish(el) && !el.contains(atc) && !atc.contains(el) && !el.closest('.cj-badges, .cjp, .cj-info, script, style, template');
    });
    if (!cands.length) return;
    var wish = cands.filter(function (el) { return !cands.some(function (o) { return o !== el && o.contains(el); }); })[0];
    if (!wish) return;
    var add = function (el, c) { if (el && !el.classList.contains(c)) el.classList.add(c); };
    var atcCell = atc; while (atcCell.parentElement && atcCell.parentElement !== row) atcCell = atcCell.parentElement;
    var wishCell;
    if (row.contains(wish)) {
      wishCell = wish; while (wishCell.parentElement !== row) wishCell = wishCell.parentElement;
    } else {
      /* Appens knap ligger uden for knap-rækken (fx som app-blok) – flyt den op ved siden af "Tilføj til kurv" */
      wishCell = wish;
      var holder = wish.closest('.shopify-app-block');
      if (holder && !holder.contains(atc)) wishCell = holder;
      if (atcCell.nextSibling !== wishCell) row.insertBefore(wishCell, atcCell.nextSibling);
    }
    if (wishCell === atcCell) return;
    add(row, 'cj-atc-row');
    add(atcCell, 'cj-atc-cell');
    add(wishCell, 'cj-wish');
    // Swish' egen knap fylder hele boksen (usynlig, men klikbar); vores hvide stjerne tegnes ovenpå.
    var hit = wishCell.matches('button, a, [role="button"]') ? wishCell : wishCell.querySelector('button, a, [role="button"]');
    if (hit && hit !== wishCell) {
      for (var n = hit; n && n !== wishCell; n = n.parentElement) add(n, 'cj-wish-fill');
    }
    [wishCell].concat(Array.prototype.slice.call(wishCell.querySelectorAll('*'))).forEach(function (host) {
      if (host.shadowRoot && !host.shadowRoot.querySelector('style[data-cj]')) {
        var st = document.createElement('style');
        st.setAttribute('data-cj', '');
        st.textContent = ':host{display:block!important}' +
          'button,a,[role=button]{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;margin:0!important;padding:0!important;border:0!important;background:transparent!important;opacity:0!important;cursor:pointer!important}';
        host.shadowRoot.appendChild(st);
      }
    });
    // Gemt i ønskelisten? (Swish markerer det typisk med aria-pressed, en "selected/active"-klasse eller en "fjern"-tekst)
    var saved = false;
    var nodes = [wishCell].concat(Array.prototype.slice.call(wishCell.querySelectorAll('*')));
    for (var i = 0; i < nodes.length && !saved; i++) {
      var el = nodes[i];
      var cls = typeof el.className === 'string' ? el.className : '';
      var lbl = ((el.getAttribute('aria-label') || '') + ' ' + (el.getAttribute('title') || '')).toLowerCase();
      if (el.getAttribute('aria-pressed') === 'true' || el.getAttribute('aria-checked') === 'true' ||
          /(^|[\s_-])(selected|is-selected|active|is-active|added|saved|in-wishlist)($|[\s_-])/i.test(cls.replace(/cj-[\w-]+/g, '')) ||
          /fjern|remove|gemt|saved|added/.test(lbl)) saved = true;
    }
    if (wishCell.classList.contains('cj-wish--saved') !== saved) wishCell.classList.toggle('cj-wish--saved', saved);
  }
  function initWish(root) {
    if (!document.body.classList.contains('template-product')) return;
    var scopes = root.querySelectorAll ? root.querySelectorAll('.product-details') : [];
    if (root.classList && root.classList.contains('product-details')) scopes = [root];
    Array.prototype.forEach.call(scopes, function (scope) {
      if (scope.dataset.cjWish) return;
      scope.dataset.cjWish = '1';
      var queued = false;
      var run = function () { queued = false; fixWish(scope); };
      run();
      if ('MutationObserver' in window) {
        new MutationObserver(function () { if (!queued) { queued = true; requestAnimationFrame(run); } })
          .observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-pressed', 'aria-checked', 'aria-label', 'title'] });
      }
    });
  }

  /* Produktside: "Style med" – Shopifys "ofte købt sammen" (complementary) med relaterede som reserve */
  function initStyleWith(root) {
    root.querySelectorAll('[data-cj-style-with]').forEach(function (box) {
      if (box.dataset.cjhBound) return;
      box.dataset.cjhBound = '1';
      var list = box.querySelector('[data-cj-style-list]');
      var limit = parseInt(box.getAttribute('data-limit'), 10) || 2;
      /* Henter ekstra, så dubletter og udsolgte kan sorteres fra og der stadig er nok */
      var base2 = box.getAttribute('data-url') + '?section_id=cj-style-with&product_id=' + box.getAttribute('data-product-id') + '&limit=' + (limit + 4);
      function load(intent) {
        return fetch(base2 + '&intent=' + intent, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            return Array.prototype.slice.call(tmp.querySelectorAll('[data-cj-style-item]'));
          })
          .catch(function () { return []; });
      }
      var seen = {};
      function add(items) {
        items.forEach(function (it) {
          if (list.children.length >= limit) return;
          var a = it.querySelector('a');
          var key = a ? a.getAttribute('href').split('?')[0] : it.textContent;
          if (seen[key]) return;
          seen[key] = true;
          list.appendChild(it);
        });
        if (list.children.length) box.hidden = false;
      }
      /* "Ofte købt sammen" først – fyldes op med relaterede, så der altid vises det ønskede antal */
      var start = function () {
        load('complementary').then(function (items) {
          add(items);
          if (list.children.length < limit) load('related').then(add);
        });
      };
      /* Hentes, når siden er færdig med at loade, så det ikke forsinker billeder og køb-knap */
      var later = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 300); })(start); };
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
    });
  }

  /* Kollektionsbeskrivelse: "Læs mere" i stedet for en tekst, der stopper med "…" */
  function initReadMore(root) {
    root.querySelectorAll('[data-cj-readmore]').forEach(function (el) {
      if (el.dataset.cjhBound) return;
      el.dataset.cjhBound = '1';
      var btn = el.parentElement.querySelector('[data-cj-readmore-btn]');
      if (!btn) return;
      var check = function () {
        if (el.classList.contains('is-open')) return;
        btn.hidden = el.scrollHeight <= el.clientHeight + 2;
      };
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-open');
        btn.textContent = open ? 'Läs mindre' : 'Läs mer';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      check();
      window.addEventListener('resize', check);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
    });
  }

  window.cjhReady = true;
  function init(root) {
    root = root || document;
    initTabs(root);
    initRails(root);
    initVideos(root);
    initReveal(root);
    initLooks(root);
    initGridPromos(root);
    initDelivery(root);
    initFit(root);
    initWish(root);
    initStyleWith(root);
    initReadMore(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Horizon udskifter dele af siden uden genindlæsning (varianter, filtre, uendelig scroll).
     Nye elementer får samme behandling – alle init-funktioner springer allerede behandlede elementer over. */
  if ('MutationObserver' in window) {
    var main = document.getElementById('MainContent');
    var t;
    if (main) {
      new MutationObserver(function (list) {
        var SEL = '.cjh, .product-details, .product-grid, [data-cjp-eta], [data-cj-style-with], [data-cj-readmore], [data-cjc-promo]';
        for (var i = 0; i < list.length; i++) {
          var added = list[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1 || n.hasAttribute('data-cj-style-item')) continue;
            if (n.matches(SEL) || n.querySelector(SEL)) {
              clearTimeout(t);
              t = setTimeout(function () { init(main); }, 150);
              return;
            }
          }
        }
      }).observe(main, { childList: true, subtree: true });
    }
  }
})();
